var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "190px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c("cargo-ag-grid", {
                staticClass: "section",
                staticStyle: {
                  "min-width": "160px",
                  width: "100%",
                  height: "100%"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "check-sub-record": false,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "deselect-sub-record": false
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "10px" }
                },
                [
                  _c("div", { staticClass: "filters" }),
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c(
                        "cargo-button-group-slider",
                        [
                          _c("finance-btn-group", {
                            staticStyle: { "flex-wrap": "wrap" },
                            attrs: {
                              "source-view": "detail",
                              job: _vm.job,
                              hp: _vm.financeDetailHp,
                              "active-tab-name": _vm.activeTabName
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { "white-space": "nowrap" } },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "red",
                              staticStyle: {
                                "font-weight": "bold",
                                "font-size": "15px",
                                height: "25px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.jobState))]
                          ),
                          (_vm.job.jobState === 0 ||
                            _vm.job.jobState === 1 ||
                            _vm.job.jobState === 2 ||
                            _vm.job.jobState === 11) &&
                          _vm.job.shutOut &&
                          !_vm.jobChangeState
                            ? _c(
                                "font",
                                {
                                  staticClass: "red",
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "15px",
                                    height: "25px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        _vm.$t("Message.HasChargeToShutOut")
                                      ) +
                                      ")"
                                  )
                                ]
                              )
                            : _vm._e(),
                          (_vm.job.jobState === 0 ||
                            _vm.job.jobState === 1 ||
                            _vm.job.jobState === 2 ||
                            _vm.job.jobState === 11) &&
                          _vm.job.shutOut &&
                          _vm.jobChangeState
                            ? _c(
                                "font",
                                {
                                  staticClass: "red",
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "15px",
                                    height: "25px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        _vm.$t("Message.HasChargeToShutOut")
                                      ) +
                                      "/" +
                                      _vm._s(_vm.jobChangeState) +
                                      ")"
                                  )
                                ]
                              )
                            : _vm._e(),
                          !(
                            (_vm.job.jobState === 0 ||
                              _vm.job.jobState === 1 ||
                              _vm.job.jobState === 2 ||
                              _vm.job.jobState === 11) &&
                            _vm.job.shutOut
                          ) && _vm.jobChangeState
                            ? _c(
                                "font",
                                {
                                  staticClass: "red",
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "15px",
                                    height: "25px"
                                  }
                                },
                                [_vm._v("(" + _vm._s(_vm.jobChangeState) + ")")]
                              )
                            : _vm._e(),
                          _c("label", [_vm._v(_vm._s(""))]),
                          _c(
                            "label",
                            {
                              staticClass: "blue",
                              staticStyle: { height: "25px" }
                            },
                            [_vm._v(_vm._s(_vm.job.jobNo))]
                          ),
                          _c(
                            "label",
                            {
                              staticClass: "blue",
                              staticStyle: { height: "25px" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$store.getters.language === "zh"
                                    ? _vm.customerChineseName
                                    : _vm.customerEnglishName
                                )
                              )
                            ]
                          ),
                          _c("span", {
                            staticStyle: {
                              "font-size": "12px",
                              padding: "5px 9px",
                              color: "unset"
                            },
                            domProps: {
                              innerHTML: _vm._s(_vm.commonInfo.jobTitle)
                            }
                          }),
                          _vm.pushExternalInterfaceStatus
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    position: "fixed",
                                    "z-index": "99",
                                    display: "flex"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { color: "#E6A23C" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.pushExternalInterfaceStatus)
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm.$t(
                                          "Clearing.NewGeneration"
                                        ),
                                        placement: "top-start"
                                      }
                                    },
                                    [
                                      _c("svg-icon", {
                                        staticStyle: {
                                          "font-size": "14px",
                                          "margin-left": "5px",
                                          "margin-top": "-2px"
                                        },
                                        attrs: { "icon-class": "question" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "card" },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          key: 10,
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_Basic"),
                            name: "basic"
                          }
                        },
                        [
                          _c("basic", {
                            ref: "basic",
                            attrs: {
                              lob: _vm.lob,
                              "master-flag": _vm.masterFlag,
                              "se-context": _vm.seContext,
                              job: _vm.job
                            }
                          })
                        ],
                        1
                      ),
                      _vm.lob === "SE"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 20,
                              attrs: {
                                lazy: true,
                                name: "tabVesselEq",
                                label: _vm.$t("CargoMsg.Cargo_Booking")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("tab-vessel-eq-UICustom", {
                                    ref: "tabVesselEq",
                                    attrs: {
                                      context: _vm.seContext,
                                      action: _vm.action
                                    }
                                  })
                                : _c("tab-vessel-eq", {
                                    ref: "tabVesselEq",
                                    attrs: {
                                      context: _vm.seContext,
                                      action: _vm.action
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.lob === "AE"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 40,
                              attrs: {
                                lazy: true,
                                name: "tabAirVesselEq",
                                label: _vm.$t("CargoMsg.Cargo_Booking")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("tab-air-vessel-eq-UICustom", {
                                    ref: "tabAirVesselEq",
                                    attrs: {
                                      context: _vm.seContext,
                                      action: _vm.action
                                    }
                                  })
                                : _c("tab-air-vessel-eq", {
                                    ref: "tabAirVesselEq",
                                    attrs: {
                                      context: _vm.seContext,
                                      action: _vm.action
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.lob === "IE" && _vm.job.containerLoadType === "TT"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 30,
                              attrs: {
                                lazy: true,
                                name: "tabGatheringTrailer",
                                label: _vm.$t("SeaExport.GatheringTrailer")
                              }
                            },
                            [
                              _c("tab-gathering-trailer", {
                                ref: "tabGatheringTrailer",
                                attrs: {
                                  context: _vm.seContext,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.lob === "IE" && _vm.job.containerLoadType === "CL"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 31,
                              attrs: {
                                lazy: true,
                                name: "tabLessThanCarload",
                                label: _vm.$t(
                                  "SeaExport.WholeVehicleLessThanCarload"
                                )
                              }
                            },
                            [
                              _c("tab-less-than-carload", {
                                ref: "tabLessThanCarload",
                                attrs: {
                                  context: _vm.seContext,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.lob === "IE" && _vm.job.containerLoadType === "IC"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 32,
                              attrs: {
                                lazy: true,
                                name: "tabOrderCar",
                                label: _vm.$t("CargoMsg.Cargo_Booking")
                              }
                            },
                            [
                              _c("tab-order-car", {
                                ref: "tabOrderCar",
                                attrs: {
                                  context: _vm.seContext,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      [
                        _vm.lob === "SE" || _vm.lob === "AE"
                          ? [
                              !_vm.chargePageSet.hideTabCharge
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      key: 21,
                                      attrs: {
                                        lazy: true,
                                        name: "tabCharges",
                                        label: _vm.$t("CargoMsg.Cargo_Cost")
                                      }
                                    },
                                    [
                                      _c("tab-charges", {
                                        ref: "tabCharges",
                                        attrs: {
                                          context: _vm.seContext,
                                          action: _vm.action,
                                          adjust: _vm.adjust,
                                          location: _vm.location,
                                          "is-from-finance": "",
                                          "view-source": "FinanceManage",
                                          "enable-ui-custom": true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.chargePageSet.arAloneShow &&
                              _vm.privilege.charge.chargeReceivable
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      key: "chargeArTab",
                                      attrs: {
                                        lazy: true,
                                        name: "tabChargesAr",
                                        label: _vm.$t("queryJob.FeeReceivable")
                                      }
                                    },
                                    [
                                      _c("tab-charges", {
                                        ref: "tabChargesAr",
                                        attrs: {
                                          context: _vm.seContext,
                                          action: _vm.action,
                                          adjust: _vm.adjust,
                                          location: _vm.location,
                                          "is-from-finance": "",
                                          "view-source": "FinanceManage",
                                          "tab-name": "tabChargesAr",
                                          type: "ar",
                                          "enable-ui-custom": true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.chargePageSet.apAloneShow &&
                              _vm.privilege.charge.chargePayable
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      key: "chargeApTab",
                                      attrs: {
                                        lazy: true,
                                        name: "tabChargesAp",
                                        label: _vm.$t("queryJob.CostsPayable")
                                      }
                                    },
                                    [
                                      _c("tab-charges", {
                                        ref: "tabChargesAp",
                                        attrs: {
                                          context: _vm.seContext,
                                          action: _vm.action,
                                          adjust: _vm.adjust,
                                          location: _vm.location,
                                          "is-from-finance": "",
                                          "view-source": "FinanceManage",
                                          "tab-name": "tabChargesAp",
                                          type: "ap",
                                          "enable-ui-custom": true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          : _c(
                              "el-tab-pane",
                              {
                                key: 21,
                                attrs: {
                                  lazy: true,
                                  name: "tabCharges",
                                  label: _vm.$t("CargoMsg.Cargo_Cost")
                                }
                              },
                              [
                                _c("tab-charges", {
                                  ref: "tabCharges",
                                  attrs: {
                                    context: _vm.seContext,
                                    action: _vm.action,
                                    adjust: _vm.adjust,
                                    location: _vm.location,
                                    "is-from-finance": "",
                                    "view-source": "FinanceManage"
                                  }
                                })
                              ],
                              1
                            )
                      ],
                      _c(
                        "el-tab-pane",
                        {
                          key: 22,
                          attrs: {
                            lazy: true,
                            name: "tabInternalBill",
                            label: _vm.$t("CargoMsg.Cargo_DomesticBill")
                          }
                        },
                        [
                          _c("tab-internal-bill", {
                            ref: "tabInternalBill",
                            attrs: {
                              context: _vm.seContext,
                              action: _vm.action,
                              location: _vm.location,
                              "enable-ui-custom":
                                _vm.$store.state.uiCustom.enable,
                              "page-type":
                                _vm.UICustomConstants
                                  .SEA_BOOKING_DOMESTIC_BILLING
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          key: 23,
                          attrs: {
                            lazy: true,
                            name: "tabOverseaBill",
                            label: _vm.$t("CargoMsg.Cargo_InternationalBill")
                          }
                        },
                        [
                          _c("tab-oversea-bill", {
                            ref: "tabOverseaBill",
                            attrs: {
                              context: _vm.seContext,
                              action: _vm.action,
                              location: _vm.location,
                              "view-source": "financeDetail",
                              "enable-ui-custom":
                                _vm.$store.state.uiCustom.enable,
                              "page-type":
                                _vm.UICustomConstants.SEA_BOOKING_OVERSEA_BILL
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          key: 24,
                          attrs: {
                            lazy: true,
                            name: "tabAdvanceCharge",
                            label: _vm.$t("CargoMsg.Cargo_AdvanceChargeInfo")
                          }
                        },
                        [
                          _c("tab-advance-charge", {
                            ref: "tabAdvanceCharge",
                            attrs: {
                              context: _vm.seContext,
                              action: _vm.action,
                              adjust: _vm.adjust,
                              location: _vm.location
                            }
                          })
                        ],
                        1
                      ),
                      _vm.showTabSopState
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 29,
                              attrs: {
                                lazy: true,
                                name: "tabSopState",
                                label: _vm.$t("CargoMsg.Cargo_BusinessStatus")
                              }
                            },
                            [
                              _c("tab-sop-state", {
                                ref: "tabSopState",
                                attrs: {
                                  context: _vm.seContext,
                                  action: _vm.action,
                                  "is-from-finance": ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          key: 28,
                          attrs: {
                            lazy: true,
                            name: "tabFileHistory",
                            label: _vm.$t("CargoMsg.Cargo_FileHistory")
                          }
                        },
                        [
                          _c("tab-file-history", {
                            ref: "tabFileHistory",
                            attrs: { context: _vm.seContext }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("update-exchange-rate-dialog", {
        attrs: {
          visible: _vm.updateExchangeRateDialog.visible,
          "job-key-list": _vm.updateExchangeRateDialog.jobKeyList,
          location: _vm.location
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.updateExchangeRateDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }